import useClientRequest from './useClientRequest';

export const requestClientExecute = (query: any, client: any, options: any) => {
      return useClientRequest(client, query, {
        isMutation: true,
        ...options,
      });
    };
